import styled from '@emotion/styled';
import { css } from 'emotion';

const Container = styled.div`
  margin-top: 20px;
`;

const FormItem = styled.div`
  margin: 15px 0;

  input,
  textarea {
    padding: 10px 16px;
    font-size: 2.4rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #292f36;
    background-color: #f2f2f3;
    border-width: 1px;
  }

  input {
    height: 50px;
  }

  textarea {
    height: 150px;
    @media (max-height: 740px) {
      height: auto;
      max-height: 150px;
    }
  }

  p {
    margin-bottom: 9px;
    font-size: 1.6rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #7f8287;
  }
`;

const buttonStyles = css`
  max-width: 300px;
  width: 100%;
  margin: auto;
  @media (max-width: 600px) {
    max-width: 100%;
  }
`;

export { Container, FormItem, buttonStyles };
